import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Arbeitsbereich } from '../../../config/model/arbeitsbereich-config.model';
import { TranslateService } from '@ngx-translate/core';
import { GlobalState } from '../../../config/model/global-state.model';
import { UrlParameterMapperService } from './url-parameter-mapper.service';
import Enums from '../../enum/enums';

@Injectable({
  providedIn: 'root',
})
export class UrlStateHelperService {
  constructor(
    private router: Router,
    private readonly translate: TranslateService,
    private readonly urlParameterMapperService: UrlParameterMapperService
  ) {}

  setState(state: Partial<GlobalState>): Promise<boolean> {
    let commands: any[];
    if (state.id) {
      commands = this.getFullCommandsFromState(state as GlobalState);
      return this.navigate(commands, { queryParams: { objectid: state.id } });
    } else if (state.guid) {
      commands = this.getFullCommandsFromState(state as GlobalState);
      return this.navigate(commands, { queryParams: { guid: state.guid } });
    } else if (state.aoid) {
      commands = this.getFullCommandsFromState(state as GlobalState);
      return this.navigate(commands, { queryParams: { aoid: state.aoid } });
    } else if (state.egrid) {
      commands = this.getFullCommandsFromState(state as GlobalState);
      return this.navigate(commands, { queryParams: { egrid: state.egrid } });
    }

    commands = this.getCommandsFromState(state as GlobalState);

    return this.navigate(commands);
  }

  private getCommandsFromState(state: GlobalState) {
    return [
      this.urlParameterMapperService.mapIdToUrl(state.workspace, Enums.UrlParameter.workspace),
    ];
  }

  private getFullCommandsFromState(state: GlobalState) {
    return [
      this.urlParameterMapperService.mapIdToUrl(state.workspace, Enums.UrlParameter.workspace),
      this.urlParameterMapperService.mapIdToUrl(state.tool, Enums.UrlParameter.tool),
      this.urlParameterMapperService.mapIdToUrl(state.layer, Enums.UrlParameter.layer),
    ];
  }

  navigateToWorkspace(workspace: Arbeitsbereich) {
    const ws = this.getWorkspaceName(workspace);
    // todo SBB-Eigentumsfläche
    if (workspace.id === Enums.Workspace.nonWorkspace) {
      this.navigate(['/']);
    } else {
      this.navigate(['/' + ws]);
    }
  }

  private navigate(commands: any[], queryParams?): Promise<boolean> {
    if (queryParams) {
      return this.router.navigate(commands, queryParams);
    }
    return this.router.navigate(commands);
  }

  private getWorkspaceName(workspace: Arbeitsbereich): string {
    return this.translate.instant(workspace.id);
  }
}
